/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { DebtorList01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const debtorList01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedResources: INITIAL_STATE.selectedResources
});

export const debtorList01FetchDebtorList01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const debtorList01FetchDebtorList01Success = (
  state,
  { resources, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  resources,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const debtorList01AddSelectedResources = (state, { selectedResources }) => {
  const selectIds = state.selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: [
      ...state.selectedResources,
      ...selectedResources.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const debtorList01RemoveSelectedResources = (state, { selectedResources }) => {
  const selectIds = selectedResources.map(value => value.id);
  return {
    ...state,
    selectedResources: state.selectedResources.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const debtorList01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [DebtorList01Types.DEBTOR_LIST01_RESET_TIMESTAMP]: debtorList01ResetTimestamp,
  [DebtorList01Types.DEBTOR_LIST01_FETCH_DEBTOR_LIST01_LOADING]: debtorList01FetchDebtorList01Loading,
  [DebtorList01Types.DEBTOR_LIST01_FETCH_DEBTOR_LIST01_SUCCESS]: debtorList01FetchDebtorList01Success,
  [DebtorList01Types.DEBTOR_LIST01_ADD_SELECTED_RESOURCES]: debtorList01AddSelectedResources,
  [DebtorList01Types.DEBTOR_LIST01_REMOVE_SELECTED_RESOURCES]: debtorList01RemoveSelectedResources,
  [DebtorList01Types.DEBTOR_LIST01_SET_WORKSPACE_VISIBLE]: debtorList01SetWorkspaceVisible
});
